import React from "react";
import Wheel from "./Wheel";

function Home() {
  return (
    <div className="App body md:py-16">
      <div className="max-w-screen-xl mx-auto p-5 md:p-4 ">
        <div className="my-5 ">
          <div className="w-full ">
            <div className="text-content text-center">
              <h1 className="text-4xl font-semibold pb-5">
                Why Is Actual Randomness Such A Big Deal?
              </h1>
              <p className="text-md pb-5">
                Ever wondered how computers, which follow strict rules, can
                create randomness? Most of the "random" numbers they use aren’t
                truly random—they're called pseudo-random and come from
                formulas. That’s usually good enough, but it’s not the same as
                the real randomness you get from rolling dice or picking lottery
                numbers. So, it might not be as random as you think!
              </p>
            </div>
          </div>
        </div>
        <Wheel />
      </div>
    </div>
  );
}

export default Home;
